module.exports = __webpack_public_path__ + "public/img/省广畅思@1x.0e61c477.png";